import React, { Component } from 'react';
import { Row, Col, Card, Icon, DatePicker } from 'antd';

import moment from 'moment';

import AddProductModal from './Modals/AddProductModal';
import ModifyAddressModal from './Modals/ModifyAddressModal';
import AddCommentModal from './Modals/AddCommentModal';
import ConfirmModal from './Modals/ConfirmModal';

import LayoutWrapper from '../UI/LayoutWrapper';
import PageHeader from '../UI/PageHeader';
import Box from '../UI/Box';
import ContentHolder from '../UI/ContentHolder';
import Button from '../UI/Button';

import OrdersNewStyleWrapper from './ordersNew.style';

class OrdersNew extends Component {
  constructor(props) {
    super(props);

    this.state = {
      productsModalOpen: false,
      addressModalOpen: false,
      commentModalOpen: false,
      confirmModalOpen: false,
      cancelModalOpen: false,
      address: {
        line1: 'Ter Waarde 50',
        line2: '8900 Ieper',
      },
      comment: null,
      cart: [],
    };
  }

  cancelOrder = () => {
    this.props.history.push('/');
  };

  confirmOrder = () => {
    this.props.history.push('new/success');
  };

  openModal = (modal) => {
    this.setState({
      ...this.state,
      [modal]: true,
    });
  };

  cancelModal = (modal) => {
    this.setState({
      [modal]: false,
    });
  };

  confirmAddress = (address) => {
    this.setState({
      ...this.state,
      addressModalOpen: false,
      address,
    });
  };

  confirmComment = (comment) => {
    this.setState({
      ...this.state,
      commentModalOpen: false,
      comment,
    });
  };

  confirmProduct = (product) => {
    this.setState({
      ...this.state,
      productsModalOpen: false,
      cart: [
        ...this.state.cart,
        product,
      ],
    });
  };

  removeFromCart = (key) => {
    this.setState({
      ...this.state,
      cart: [
        ...this.state.cart.slice(0, key),
        ...this.state.cart.slice(key + 1),
      ],
    });
  }

  render() {
    const dateFormat = 'DD/MM/YYYY';
    return (
      <OrdersNewStyleWrapper>
        <LayoutWrapper>
          <PageHeader>Nieuwe bestelling</PageHeader>
          <Box>
            <ContentHolder>
              <Row
                gutter={16}
                justify="start"
              >
                <Col
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <h2 style={{ marginBottom: '10px' }}>Leveradres</h2>
                  <Card bodyStyle={{ padding: '16px' }} noHovering>
                    <p>
                      {this.state.address.line1}<br />
                      {this.state.address.line2}
                    </p>
                    <p onClick={() => this.openModal('addressModalOpen')}>
                      <Icon type="right" style={{color: '#1A73A7'}} /> <span style={{ cursor: 'pointer', border: '0', color: '#1A73A7' }}>Wijzig leveradres</span>
                    </p>
                  </Card>
                  <h2 style={{ marginBottom: '10px', marginTop: '20px' }}>Leverdatum</h2>
                  <Card bodyStyle={{ padding: '16px' }} noHovering>
                    <DatePicker
                      defaultValue={moment()}
                      format={dateFormat}
                      size="large"
                      showToday={false}
                      placeholder="Selecteer een datum"
                      allowClear={false}
                    />
                  </Card>
                  <h2 style={{ marginBottom: '10px', marginTop: '20px' }}>Opmerkingen</h2>
                  <Card style={{ marginBottom: '20px' }} bodyStyle={{ padding: '16px' }} noHovering>
                    {this.state.comment &&
                      <p>
                        {this.state.comment}
                      </p>
                    }
                    <p onClick={() => this.openModal('commentModalOpen')}>
                      <Icon type="right" style={{color: '#1A73A7'}} /> <span style={{ cursor: 'pointer', border: '0', color: '#1A73A7' }}>Opmerking toevoegen</span>
                    </p>
                  </Card>
                </Col>
                <Col
                  md={12}
                  sm={24}
                  xs={24}
                >
                  <h2 style={{ marginBottom: '10px' }}>Producten</h2>
                  {this.state.cart.length > 0 ?
                    this.state.cart.map((product, k) => (
                    <Card key={`cart_${k}`} style={{ marginBottom: '10px' }} bodyStyle={{ padding: '16px' }} noHovering>
                      <div className="isoLeftRightComponent">
                        <div>
                          <h2>{product.name}</h2>
                          <p>{product.category}</p>
                        </div>
                        <div className="productControl">
                          <h2 style={{ marginRight: '20px' }}>20 Palletten</h2>
                          <Button type="button">
                            <Icon type="edit" />
                          </Button>
                          <Button type="button" onClick={() => this.removeFromCart(k)}>
                            <Icon type="delete" />
                          </Button>
                        </div>
                      </div>
                    </Card>
                  ))
                    :
                    <Card bodyStyle={{ padding: '16px', fontSize: '14px' }} noHovering>
                      <p>Geen producten toegevoegd</p>
                    </Card>
                  }
                  <div className="isoLeftRightComponent" style={{marginBottom: '20px'}}>
                    <div />
                    <Button type="primary" style={{marginTop: '20px'}} onClick={() => this.openModal('productsModalOpen')}>Product toevoegen</Button>
                  </div>
                </Col>
              </Row>
            <div className="isoLeftRightComponent">
              <div />
              <div>
                <Button style={{margin: '0 20px 0 0'}} onClick={() => this.openModal('cancelModalOpen')}>Annuleren</Button>
                <Button type="primary" onClick={() => this.openModal('confirmModalOpen')}>Bestellen</Button>
              </div>
            </div>
            <AddProductModal
              open={this.state.productsModalOpen}
              onConfirm={this.confirmProduct}
              onClose={() => this.cancelModal('productsModalOpen')}
            />
            <ModifyAddressModal
              open={this.state.addressModalOpen}
              onConfirm={this.confirmAddress}
              onClose={() => this.cancelModal('addressModalOpen')}
              address={this.state.address}
            />
            <AddCommentModal
              open={this.state.commentModalOpen}
              onConfirm={this.confirmComment}
              onClose={() => this.cancelModal('commentModalOpen')}
              comment={this.state.comment}
            />
            <ConfirmModal
              open={this.state.confirmModalOpen}
              onConfirm={this.confirmOrder}
              onClose={() => this.cancelModal('confirmModalOpen')}
              text="Weet u zeker dat u wilt bestellen?"
            />
            <ConfirmModal
              open={this.state.cancelModalOpen}
              onConfirm={this.cancelOrder}
              onClose={() => this.cancelModal('cancelModalOpen')}
              text="Weet u zeker dat u deze bestelling wilt verlaten?"
              width="420px"
            />
            </ContentHolder>
          </Box>
        </LayoutWrapper>
      </OrdersNewStyleWrapper>
    );
  }
}

export default OrdersNew;


// WEBPACK FOOTER //
// ./src/components/Orders/OrdersNew.js